import React, { Component } from "react";
import PropTypes from "prop-types";
import { Deedle, View } from "components";
import moment from "moment-timezone";
import { AmericanDateFormat, capitalize } from "utils/formatters";

const fallbackText = (text = "", fallback = "-") => {
  return text && text.length ? text : fallback;
};

function displayText(communication) {
  if (
    !Object.keys(communication).length ||
    (!communication.sentTime.length && !communication.senderRole.length)
  ) {
    return "N/A";
  }

  return `${moment(communication.sentTime)
    .tz("America/New_York")
    .format(AmericanDateFormat)}`;
}

const communicationType = PropTypes.shape({
  sentTime: PropTypes.string,
  senderRole: PropTypes.string,
});

class EnrollmentStatus extends Component {
  static propTypes = {
    debtor: PropTypes.object.isRequired,
    emailCommunication: communicationType,
    downloadCommunication: communicationType,
    faxCommunication: communicationType,
  };

  render() {
    const {
      debtor,
      downloadCommunication,
      emailCommunication,
      faxCommunication,
    } = this.props;
    const emailDefinition = displayText(emailCommunication);
    const faxDefinition = displayText(faxCommunication);
    const downloadDefinition = displayText(downloadCommunication);

    return (
      <aside>
        <View style={styles.emailContainer}>
          <Deedle
            term="Time Direct Deposit Form Emailed"
            definition={emailDefinition}
          />
        </View>
        <View style={styles.downloadContainer}>
          <Deedle
            term="Time Direct Deposit Form Downloaded"
            definition={downloadDefinition}
          />
        </View>
        <View style={styles.faxContainer}>
          <Deedle
            term="Time Direct Deposit Form Faxed"
            definition={faxDefinition}
          />
        </View>
        <View style={styles.statusContainer}>
          <Deedle
            term="Status"
            definition={
              <span style={styles.status}>{capitalize(debtor.status)}</span>
            }
          />
        </View>
        <View style={styles.wageNumberContainer}>
          <Deedle
            term="Wage Number"
            definition={fallbackText(debtor.wageNumber)}
          />
        </View>
        {debtor.moneygramEligible && (
          <View style={styles.moneygramContainer}>
            <a
              className="button mgi"
              href={`/paralegal/moneygram_cards/${debtor.id}.pdf`}
            >
              Print MoneyGram Card
            </a>
          </View>
        )}
      </aside>
    );
  }
}

const containerStyle = {
  padding: 10,
  backgroundColor: "white",
  marginBottom: 15,
};

const styles = {
  emailContainer: {
    ...containerStyle,
  },
  downloadContainer: {
    ...containerStyle,
  },
  statusContainer: {
    ...containerStyle,
  },
  faxContainer: {
    ...containerStyle,
  },
  wageNumberContainer: {
    ...containerStyle,
    marginBottom: 0,
  },
  status: {
    color: "#bc2a2a",
  },
};

export default EnrollmentStatus;
